import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type hireDateUpdatePayloadType = {
	group_number: number;
	role: string;
	SSN: string;
	hire_date: string;
};

const initialRoute = "auth";

export const hireDateUpdate = async (hireDateUpdatePayload: hireDateUpdatePayloadType) => {
	try {
		const payload = JSON.stringify(hireDateUpdatePayload);
		const endpoint = `${initialRoute}/hire-date-update`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				// const {
				// 	data: { result }
				// } = response;
				return message;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
